import React, { useState } from 'react';
import PropTypes from 'prop-types';
import WBottomBtnsBar from "../WBottomBtnsBar";

const WRadioStep = ({ fieldName, options, onNext, onBack, isBackVisible }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    const handleOptionChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleNextClick = () => {
        const selectedOption = options.find(option => option.value === selectedValue);
        if (onNext && selectedOption) {
            onNext({ value: selectedOption.value, next: selectedOption.next, fieldName });
        }
    };

    return (
        <div className="wui content-container">
            <form className="wui radio-step-form">
                {options.map((option, index) => (
                    <div key={index} className="wui radio-option">
                        <label className="wui radio-label">
                            <input
                                type="radio"
                                name={fieldName} 
                                value={option.value}
                                className="wui radio-input"
                                checked={selectedValue === option.value} 
                                onChange={handleOptionChange}
                            />
                            {option.options.text}
                        </label>
                    </div>
                ))}
            </form>
            <div className="wui button-bar">
                {isBackVisible && (
                    <WBottomBtnsBar
                        onBack={() => onBack && onBack()}
                        isNextVisible={false}
                    />
                )}
                <button
                    type="button"
                    className={`wui action-button ${!selectedValue ? 'disabled' : ''}`}
                    onClick={handleNextClick}
                    disabled={!selectedValue}
                >
                    Weiter
                </button>
            </div>
        </div>
    );
};

WRadioStep.propTypes = {
    fieldName: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            next: PropTypes.string,
            options: PropTypes.shape({
                text: PropTypes.string.isRequired,
            }).isRequired,
        })
    ).isRequired,
    onNext: PropTypes.func,
    onBack: PropTypes.func,
    isBackVisible: PropTypes.bool,
};

export default WRadioStep;
